import { React, useState, useEffect } from "react";
import "../.././Style/LandingPage/News.scss";
import axios from "axios";
import NewsCard from "./NewsCard";
import EventCard from "./EventCard";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import LoadingScreen from "react-loading-screen";

function News() {
  const [notice, setNotice] = useState([]);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const getNotice = async () => {
    await axios.get("https://unesco-backend.vercel.app/notice").then((res) => {
      const data = res.data;
      setNotice(data);
    });
  };

  const getEvents = async () => {
    await axios
      .get("https://unesco-backend.vercel.app/upcomingevent")
      .then((res) => {
        const data = res.data;
        setEvents(data);
      });
  };

  useEffect(() => {
    const fetchData = async () => {
      await getNotice();
      await getEvents();
      setLoading(false);
    };

    fetchData();
  }, []);

  return (
    <>
      <LoadingScreen
        loading={loading}
        bgColor="#ffffff"
        spinnerColor="#01471B"
        textColor="#01471B"
        logoSrc="https://res.cloudinary.com/unesco-admin/image/upload/v1645289463/image003-removebg-preview_dkzzc8.png"
        text="Loading...."
      ></LoadingScreen>

      <div className="NEWS">
        <div className="news">
          <div className="top">
            <div className="cont1">
              <h1>News</h1>
            </div>

            {notice.length > 0 ? (
              <Carousel
                showArrows={true}
                infiniteLoop={true}
                autoPlay={true}
                showStatus={false}
                showThumbs={false}
                stopOnHover={true}
                showIndicators={false}
              >
                {notice.map((value, index) => {
                  return <NewsCard data={value} />;
                })}
              </Carousel>
            ) : null}
          </div>

          <div className="bottom">
            {events.length > 0 ? (
              <Carousel
                showArrows={true}
                infiniteLoop={true}
                autoPlay={true}
                showStatus={false}
                showThumbs={false}
                stopOnHover={true}
                showIndicators={false}
              >
                {events.map((value, index) => {
                  return <EventCard data={value} />;
                })}
              </Carousel>
            ) : null}
            <div className="cont1">
              <h1>Upcoming Events</h1>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default News;
